import styled from 'styled-components';

const ControlsStyled = styled.div`
  .Controls {
    &__arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background-color: hsla(0, 0%, 75%, 0.5);
      border-radius: 4px;

      &--left {
        left: 1%;
      }

      &--right {
        right: 1%;
      }
    }

    &__icon {
      path {
        fill: hsl(0, 0%, 0%);
      }
    }
  }
`;

export { ControlsStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
